import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  align-items: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  h3 {
    margin: 100px 0;
  }

  .lessonHeader {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: calc(100vh - 65px);
  }
`;

export const HeaderRight = styled.div`
  width: 300px;
  max-width: 300px;
  display: flex;
  background-color: #404040;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px;

  @media (max-width: 1200px) {
    display: none;
  }
  h4 {
    color: #fff;
    font-size: 16px;
    margin-bottom: 15px;
    width: 100%;
  }

  div {
    padding: 10px 12px;
    background-color: #343434;
    color: #fff;
    width: 270px;
    display: flex;
    margin-bottom: 15px;
    border-radius: 10px;
    flex-direction: column;
    align-items: flex-end;
    cursor: pointer;

    h4 {
      color: #fff;
      font-size: 14px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    p {
      width: 100%;
      margin-top: 5px;
      font-size: 12px;
      margin: 8px 0;
      color: #fff;
    }
    &:hover,
    &.active {
      background-color: #6d6d6d;
    }
  }
  .lesson {
    background-color: #6d6d6d;
  }

  .disabled {
    opacity: 0.5;
    cursor: default;
    &:hover,
    &.active {
      background-color: #343434;
    }
  }
`;

export const Lesson = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 35px;

  h3 {
    width: 100%;
    font-size: 24px;
    margin: 0 0 10px 0;
    text-align: left;
    font-weight: 700;
  }

  p {
    width: 100%;
    font-size: 14px;
    margin: 0 0 20px 0;
    text-align: left;
    font-weight: 300;
  }

  iframe {
    width: 856px;
    height: 452px;

    @media (max-width: 1200px) {
      width: 100%;
      height: calc(92vw / 2);
    }
  }
`;
